import { render, staticRenderFns } from "./BusinessV2.vue?vue&type=template&id=640de24a&scoped=true"
import script from "./BusinessV2.vue?vue&type=script&lang=js"
export * from "./BusinessV2.vue?vue&type=script&lang=js"
import style0 from "./BusinessV2.vue?vue&type=style&index=0&id=640de24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640de24a",
  null
  
)

export default component.exports